import React, { useState, useEffect } from 'react';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, InputLabel, Select, Stack, TextField } from '@mui/material/';

//components import
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';

interface PlaceHolderItemDialogProps {
    issueId: number,
    isPlaceHolderItemDialogOpen: boolean,
    closePlaceHolderItemDialog: () => void,
}

const PlaceHolderItemDialog = (props: PlaceHolderItemDialogProps) => {

    const addPlaceHolderItem = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries((formData as any).entries());
        const ordinal = formJson.ordinal;
        const date = formJson.date;
        const name = formJson.name;
        const groupUi = formJson.groupUi;
        const description = formJson.description;
        const occupation = formJson.occupation;
        const employer = formJson.employer;
        const amount = formJson.amount;
        const auditNote = formJson.auditNote;

        var params = [
            `issueId=${props.issueId}`,
            `groupUi=${groupUi}`,
            `ordinal=${ordinal}`,
            `date=${date}`,
            `name=${name}`,
            `description=${description}`,
            `occupation=${occupation}`,
            `employer=${employer}`,
            `amount=${amount}`,
            `auditNote=${auditNote}`
        ].join('&');

        let url = `/Archer3/SavePlaceholderItem?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: SavePlaceHolderItem',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    props.closePlaceHolderItemDialog();
                }
            })
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <>
            <Dialog
                open={props.isPlaceHolderItemDialogOpen}
                onClose={props.closePlaceHolderItemDialog}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => addPlaceHolderItem(event)
                }}
            >
                <DialogTitle>Attach a new customized row to the flagged item list</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <TextField
                            margin="dense"
                            name="ordinal"
                            label="Ordinal: where are you going to insert the customized row (for non-group item)? put row number here"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="groupUi"
                            label="Group UI: which group are you going to add a customized row (excess-5)?"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="date"
                            label="Date"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            required
                            margin="dense"
                            name="name"
                            label="Name"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="description"
                            label="Description"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="occupation"
                            label="Occupation"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="employer"
                            label="Employer"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="amount"
                            label="Amount"
                            fullWidth
                            variant="standard"
                        />
                        <TextField
                            margin="dense"
                            name="auditNote"
                            label="Audit Note"
                            fullWidth
                            variant="standard"
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.closePlaceHolderItemDialog}>Cancel</Button>
                    <Button type="submit">Add</Button>
                </DialogActions>
            </Dialog>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )

}

export default PlaceHolderItemDialog;